import { privateInstance } from "../configs";

export const recipeProductCategoryApi = {
  async getRecipeProductCategories() {
    const res = await privateInstance.get(
      `/recipes/api/categories/product/list/`
    );
    return res.data;
  },
  async postRecipeProductCategory(category) {
    const res = await privateInstance.post(
      `/recipes/api/categories/product/list/`,
      category
    );
    return res.data;
  },
  async retrieveRecipeProductCategory(id) {
    const res = await privateInstance.get(
      `/recipes/api/categories/product/${id}/`
    );
    return res.data;
  },
  async putRecipeProductCategory(id, category) {
    const res = await privateInstance.put(
      `/recipes/api/categories/product/${id}/`,
      category
    );
    return res.data;
  },
  async patchRecipeProductCategory(id, category) {
    const res = await privateInstance.patch(
      `/recipes/api/categories/product/${id}/`,
      category
    );
    return res.data;
  },
  async deleteRecipeProductCategory(id) {
    const res = await privateInstance.delete(
      `/recipes/api/categories/product/${id}/`
    );
    return res.data;
  }
};
